/* eslint-disable react/prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';

import { Input, Select, Form } from 'antd';

const { Option } = Select;

const TransactionSettlementForm = ({
  form, handleStatusChange, selectedTransaction, selectedStatus,
}) => {
  const transactionStatuses = ['COMPLETED', 'CANCELLED', 'FAILED'].map((tStatus) => (
    <Option key={tStatus} value={tStatus}>
      {tStatus}
    </Option>
  ));

  return (
    <Form
      name="basic"
      className="gx-form-row0"
      ref={form}
      initialValues={{
        processor_fee: selectedTransaction.processor_fee,
        processor_reference: selectedTransaction.processor_reference,
        narration: selectedTransaction.narration,
        transaction_status: selectedTransaction.transaction_status,
        kitegateway_reference: selectedTransaction.kitegateway_reference,
      }}
    >
      <div>New Status</div>
      <Form.Item>
        <Select
          allowClear
          showArrow
          style={{ width: '100%' }}
          placeholder="Please select status"
          onChange={(e) => handleStatusChange(e)}
          defaultValue={selectedStatus}
        >
          {transactionStatuses}
        </Select>
      </Form.Item>

      {selectedStatus && !['FAILED', 'CANCELLED'].includes(selectedStatus)
        && (
          <>
            <div>Processor/Bank Fees</div>
            <Form.Item
              rules={[
                { required: true, message: 'This input is required!' },
              ]}
              name="processor_fee"
            >
              <Input placeholder="Usually from the final acquirer" />
            </Form.Item>

            <div>Processor/Bank Reference</div>
            <Form.Item
              rules={[
                { required: true, message: 'This input is required!' },
              ]}
              name="processor_reference"
            >
              <Input placeholder="e.g Transaction ID on the PSP side" />
            </Form.Item>
          </>
        )}

      <div>Narration</div>
      <Form.Item
        rules={[
          { required: true, message: 'This input is required!' },
        ]}
        name="narration"
      >
        <Input placeholder="Any extra information" />
      </Form.Item>
      <Form.Item
        name="kitegateway_reference"
      >
        <Input readOnly />
      </Form.Item>
    </Form>
  );
};

TransactionSettlementForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  handleStatusChange: PropTypes.func.isRequired,
  selectedTransaction: PropTypes.oneOfType([
    PropTypes.object,
  ]).isRequired,
  selectedStatus: PropTypes.string.isRequired,
};

TransactionSettlementForm.defaultProps = {
  form: {},
};

export default TransactionSettlementForm;
